import { base64Encode, base64Decode } from './base64';
import config from '../config';

/**
 * Create a "texts" import string (messages only, for appending to a text group)
 */
export function createTextsImportString(messages) {
  const payload = {
    v: config.format.version,
    addon: config.format.addonName,
    type: 'texts',
    data: { messages },
  };
  return base64Encode(JSON.stringify(payload));
}

/**
 * Create a "textgroup" import string (full text group with settings)
 */
export function createTextGroupImportString({ name, channel, mode, messages, icon, spellId, spellName }) {
  const payload = {
    v: config.format.version,
    addon: config.format.addonName,
    type: 'textgroup',
    data: {
      name: name || 'Imported Group',
      channel: channel || 'SAY',
      mode: mode || 'SEQUENTIAL',
      messages: messages || [],
      icon: icon || null,
      spellId: spellId || null,
      spellName: spellName || null,
    },
  };
  return base64Encode(JSON.stringify(payload));
}

/**
 * Decode an import string and return the payload
 */
export function decodeImportString(base64str) {
  if (!base64str || !base64str.trim()) return null;

  const json = base64Decode(base64str.trim());
  if (!json) return null;

  try {
    const payload = JSON.parse(json);
    if (!payload.v || !payload.type) return null;
    return payload;
  } catch {
    return null;
  }
}

/**
 * Get a human-readable summary of an import payload
 */
export function getPayloadSummary(payload) {
  if (!payload || !payload.data) return null;

  const { type, data } = payload;

  switch (type) {
    case 'texts':
      return { type, messageCount: data.messages?.length || 0 };
    case 'textgroup':
      return { type, name: data.name, messageCount: data.messages?.length || 0, channel: data.channel, mode: data.mode };
    case 'group':
      return { type, name: data.name, childCount: data.children?.length || 0 };
    case 'full':
      return { type, groupCount: data.groups?.length || 0, parentCount: data.parentGroups?.length || 0 };
    default:
      return { type };
  }
}
